var map = {
	"./Design/Desktop - 1.png": 6979,
	"./icons/Frame 5.svg": 5299,
	"./icons/HelpThePack.png": 2952,
	"./icons/MRI.png": 3947,
	"./icons/Mostaql.svg": 8192,
	"./icons/Talent.png": 6203,
	"./icons/adobe.png": 4540,
	"./icons/aiml.svg": 3830,
	"./icons/angle-down-solid (3).svg": 5487,
	"./icons/angular.png": 5447,
	"./icons/arrow-left-solid.svg": 6366,
	"./icons/arrow-right-solid.svg": 1085,
	"./icons/aws.png": 2174,
	"./icons/axios.svg": 7711,
	"./icons/balsamiq.png": 3737,
	"./icons/bitbucket.png": 8178,
	"./icons/bootstrap.png": 2071,
	"./icons/bootstrap.svg": 8983,
	"./icons/brush-fill.svg": 7737,
	"./icons/c++.png": 8420,
	"./icons/carify.jpg": 189,
	"./icons/citi.png": 8896,
	"./icons/cloud.svg": 1326,
	"./icons/code-slash 1.svg": 9809,
	"./icons/code.png": 3986,
	"./icons/code.svg": 3048,
	"./icons/css3-alt.svg": 7937,
	"./icons/cummins.png": 3955,
	"./icons/database.svg": 5228,
	"./icons/django.svg": 1798,
	"./icons/docker.png": 7021,
	"./icons/dyanamo.png": 6284,
	"./icons/excel.png": 1984,
	"./icons/express.png": 5093,
	"./icons/figma.png": 9217,
	"./icons/flask.svg": 8356,
	"./icons/framer.png": 4502,
	"./icons/furniture.png": 4239,
	"./icons/gamification-robotics-coding.jpeg": 3648,
	"./icons/git-alt.svg": 359,
	"./icons/git.png": 5705,
	"./icons/github.svg": 7394,
	"./icons/github2.svg": 5164,
	"./icons/grad.png": 4873,
	"./icons/html.png": 8082,
	"./icons/html5.png": 85,
	"./icons/html5.svg": 9585,
	"./icons/instagram.svg": 5373,
	"./icons/java.png": 1401,
	"./icons/jenkins.png": 4083,
	"./icons/jira.png": 6637,
	"./icons/junit.png": 1949,
	"./icons/jupyter.png": 3514,
	"./icons/jwt.png": 7630,
	"./icons/k8.png": 9364,
	"./icons/k8.svg": 9582,
	"./icons/kafka.svg": 23,
	"./icons/laptop-code-solid.svg": 4473,
	"./icons/linkedin.svg": 6049,
	"./icons/mail.png": 5692,
	"./icons/mail.svg": 9814,
	"./icons/matplotlib.png": 8013,
	"./icons/maven.png": 816,
	"./icons/mongodb.png": 3723,
	"./icons/mui.svg": 5018,
	"./icons/mysql.png": 5575,
	"./icons/ncsu.png": 6672,
	"./icons/nextjs.png": 9427,
	"./icons/node.png": 2997,
	"./icons/numpy.png": 4736,
	"./icons/open.png": 8785,
	"./icons/openshift.png": 4681,
	"./icons/oracle.png": 9407,
	"./icons/pandas.png": 46,
	"./icons/plotly.png": 5213,
	"./icons/postgresql.png": 8359,
	"./icons/postman.svg": 9463,
	"./icons/powerbi.png": 8005,
	"./icons/prototyping.png": 8926,
	"./icons/python.png": 4531,
	"./icons/quote-left-solid.svg": 7475,
	"./icons/r.png": 5871,
	"./icons/rail.jpg": 9661,
	"./icons/react.svg": 8032,
	"./icons/redis.png": 444,
	"./icons/redux.svg": 1407,
	"./icons/sass.svg": 3697,
	"./icons/shyena.jpeg": 6138,
	"./icons/sketch.png": 6233,
	"./icons/sklearn.png": 3125,
	"./icons/spring.png": 546,
	"./icons/square-js.svg": 7390,
	"./icons/stack.png": 8614,
	"./icons/star-of-life-solid.svg": 4240,
	"./icons/star-solid.svg": 3837,
	"./icons/supplypoint.png": 4640,
	"./icons/tableau.png": 607,
	"./icons/tailwind-css.svg": 6377,
	"./icons/tailwindcss.svg": 9676,
	"./icons/twitter.svg": 8592,
	"./icons/typescript.png": 6772,
	"./icons/user-tie-solid.svg": 725,
	"./icons/wcag.png": 3335,
	"./icons/web.svg": 9215,
	"./icons/whatsapp.svg": 4609,
	"./icons/work.png": 7962,
	"./icons/x-lg.svg": 7221,
	"./images/Logo.png": 5926,
	"./images/Personal_Image.jpeg": 218,
	"./paintings/24CB5B23-1E89-43D2-8E5E-E038CA165ADF.jpg": 4849,
	"./paintings/8A950CAE-ACA8-4AEE-A2DE-128366CF17B4.jpg": 1117,
	"./paintings/IMG_6707.jpg": 7764,
	"./paintings/IMG_6708.jpg": 5239,
	"./paintings/IMG_6709.jpg": 3082,
	"./paintings/IMG_6710.jpg": 8400,
	"./paintings/IMG_6711.jpg": 7629,
	"./paintings/IMG_6712.jpg": 7730,
	"./paintings/IMG_6714.jpg": 7700,
	"./paintings/IMG_6715.jpg": 5745,
	"./simplii.jpg": 3597,
	"./simplii.png": 9421,
	"./skills/backend.png": 743,
	"./skills/cloud.png": 9020,
	"./skills/data.png": 2231,
	"./skills/frontend.png": 1587,
	"./skills/uiux.png": 1098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2181;